jQuery($ => {

    function openAccountList(el) {
        const $select = $(el).closest('.m-account-select');
        const $option = $select.find(".m-account-select__item--selected, .m-account-select__item:first-child");

        $select.addClass("m-account-select--open");
        $option.focus();
    }

    function closeAccountList(el) {
        const $select = $(el).closest('.m-account-select');
        const $trigger = $select.find(".m-account-select__trigger");

        $select.removeClass("m-account-select--open");
        $trigger.focus();
    }

    function toggleAccountList(el) {
        const $select = $(el).closest('.m-account-select');

        if ($select.is('.m-account-select--open')) {
            closeAccountList(el);
        } else {
            openAccountList(el);
        }
    }

    if ($('.m-account-select')[0]) {
        $('.m-account-select__trigger').mousedown(function (e) {
            e.preventDefault();
            toggleAccountList(this);
        });

        $(".m-account-select__trigger").keydown(function (e) {
            switch (e.key) {
                case "Enter":
                case "spacebar":
                case " ":
                case "ArrowDown":
                case "ArrowUp":
                    e.preventDefault();
                    openAccountList(this);
                    break;
            }
        });

        $(".m-account-select__item").keydown(function (e) {
            switch (e.key) {
                case "Escape":
                case "Esc":
                case "Tab":
                case "Delete":
                case "Backspace":
                    e.preventDefault();

                    closeAccountList(this);
                    break;

                case "ArrowUp":
                    e.preventDefault();

                    var prevItem = e.target.previousElementSibling;
                    if (prevItem) prevItem.focus();
                    break;

                case "ArrowDown":
                    e.preventDefault();

                    var nextItem = e.target.nextElementSibling;
                    if (nextItem) nextItem.focus();
                    break;

                case "Home":
                    e.preventDefault();

                    $(this).parent().find('.m-account-select__item:first-child').focus();
                    break;

                case "End":
                    e.preventDefault();

                    $(this).parent().find('.m-account-select__item:last-child').focus();
                    break;
            }
        });

        $(".m-account-select__item").blur(function (e) {
            const newTarget = e.relatedTarget;

            if (
                newTarget === null
                || !newTarget.classList.contains("m-account-select__item")
                || (!$(newTarget.parentElement).is('.m-account-select__wrapper') && !$(newTarget.parentElement).is('.m-account-select__list'))
            ) {
                closeAccountList(this);
            }
        });
    }
});